import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import NumberFormat from 'react-number-format';

export default class SalaryBase extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/salarybase/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.year)) this.state.data.record.year = 0;
        if (this.isBlank(this.state.data.record.kharobar)) this.state.data.record.kharobar = 0;
        if (this.isBlank(this.state.data.record.salary)) this.state.data.record.salary = 0;
        if (this.isBlank(this.state.data.record.olad)) this.state.data.record.olad = 0;
        if (this.isBlank(this.state.data.record.maskan)) this.state.data.record.maskan = 0;
        if (this.isBlank(this.state.data.record.monthBase)) this.state.data.record.monthBase = 0;
        if (this.isBlank(this.state.data.record.taxExemption)) this.state.data.record.taxExemption = 0;
        if (this.isBlank(this.state.data.record.maxTax)) this.state.data.record.maxTax = 0;
        if (this.isBlank(this.state.data.record.otherLevelPercent)) this.state.data.record.otherLevelPercent = 0;
        if (this.isBlank(this.state.data.record.otherLevelPrice)) this.state.data.record.otherLevelPrice = 0;
        if (this.isBlank(this.state.data.record.mariage)) this.state.data.record.mariage = 0;
        if (this.isBlank(this.state.data.record.family)) this.state.data.record.family = 0;

        this.httpPost("api/v1/salarybase/save", {
            id: this.getCurrentFormId(),
            year: parseInt(this.state.data.record.year),
            kharobar: parseInt(this.state.data.record.kharobar),
            salary: parseInt(this.state.data.record.salary),
            olad: parseInt(this.state.data.record.olad),
            maskan: parseInt(this.state.data.record.maskan),
            monthBase: parseInt(this.state.data.record.monthBase),
            taxExemption: parseInt(this.state.data.record.taxExemption),
            maxTax: parseInt(this.state.data.record.maxTax),
            otherLevelPercent: parseInt(this.state.data.record.otherLevelPercent),
            otherLevelPrice: parseInt(this.state.data.record.otherLevelPrice),
            mariage: parseInt(this.state.data.record.mariage),
            family: parseInt(this.state.data.record.family)
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/salarybase'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">اطلاعات بخش نامه</h5>
                                        </div>
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">سال</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.year} onChange={e => this.state.data.record.year = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">مزد روزانه</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.salary} onChange={e => this.state.data.record.salary = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">مزد پایه سنوات ماهانه</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.monthBase} onChange={e => this.state.data.record.monthBase = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">حق اولاد</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.olad} onChange={e => this.state.data.record.olad = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">حق مسکن</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.maskan} onChange={e => this.state.data.record.maskan = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">حق خوار و بار</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.kharobar} onChange={e => this.state.data.record.kharobar = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">معافیت مالیاتی</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.taxExemption} onChange={e => this.state.data.record.taxExemption = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">حداکثر مالیات سالانه</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.maxTax} onChange={e => this.state.data.record.maxTax = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">درصد سایر سطوح</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.otherLevelPercent} onChange={e => this.state.data.record.otherLevelPercent = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">مبلغ سایر سطوح</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.otherLevelPrice} onChange={e => this.state.data.record.otherLevelPrice = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">حق تاهل</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.mariage} onChange={e => this.state.data.record.mariage = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">حق عائله مندی</label>
                                                    <div className="form-control-wrap">
                                                        <NumberFormat value={this.state.data.record.family} onChange={e => this.state.data.record.family = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}